import { AxiosError } from "axios";
import { AplError } from "../types/aplError";

function isAplError(obj: any): obj is AplError {
    return obj && typeof obj === "object" && "title" in obj && "status" in obj && "detail" in obj;
}

const getAplError = (axiosError: AxiosError, aplError: AplError): AplError => {
    if (isAplError(aplError)) return aplError;

    return {
        title: axiosError.name,
        status: axiosError.status,
        detail: axiosError.message,
        aplErrorCode: null,
        type: null
    } as AplError;
};

export { getAplError };
